export class StateMessageDto {
    constructor() {
        this.parameter = "";
        this.timestamp = "";
        this.value = "";
        this.description = "";
    }
    static fromJson(stateStructure) {
        let stateMessage = new StateMessageDto();
        stateMessage.parameter = stateStructure[0];
        stateMessage.timestamp = stateStructure[1];
        stateMessage.value = stateStructure[2];
        stateMessage.description = stateStructure[3];
        return stateMessage;
    }
}
//# sourceMappingURL=StateMessageDto.js.map